import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { AUTH_USER_TOKEN_KEY } from 'constants/auth'
import { cookieService } from 'services/cookie.service'

const URL = process.env.REACT_APP_BASE_API_URL

export const mhfcAuthApiSlice = createApi({
  // unique API idetifier for redux store.
  reducerPath: 'api',
  // All of our requests will have URLs starting with '/api'.
  baseQuery: fetchBaseQuery({
    baseUrl: `${URL}/api/`, // ? currently first version of api - v1.
    prepareHeaders: (headers) => {
      headers.delete('X-Requested-With')
      headers.set('Content-Type', 'application/json')
      // Retrieve token from cookies and local storage.
      const tokenFromCookie = cookieService.getCookie(AUTH_USER_TOKEN_KEY)
      const tokenFromLocalStorage = localStorage.getItem(AUTH_USER_TOKEN_KEY)

      const mhfcToken = tokenFromCookie || tokenFromLocalStorage
      if (mhfcToken) {
        headers.set('Authorization', `Bearer ${mhfcToken}`)
      } else {
        console.log('No token found. Skipping Authorization header.')
      }

      return headers
    },
  }),
  endpoints: () => ({}),
  tagTypes: ['User'],
})
